import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import "../assets/CSS/Dashboard.css";

function ViewCheckPoints() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({ searchQuery: "", fromDate: "", toDate: "" });
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [remarks, setRemarks] = useState({});
    // Logged-in user
 const user = JSON.parse(localStorage.getItem("userData")); // make sure it's loaded

  const toggleSidebar = () => setIsSidebarVisible(vis => !vis);

  const fetchCheckPoints = useCallback(async () => {
    try {
      const response = await axiosInstance.get("api/get-CheckPoint-FormData");
      const allData = response.data || [];
      setData(allData);
      setFilteredData(allData);
    } catch (error) {
      console.error("Error fetching checkpoints data:", error);
    }
  }, []);

  useEffect(() => {
    fetchCheckPoints();
  }, [fetchCheckPoints]);

  // Handle filter input changes
  const handleFilterChange = e => {
    const { name, value } = e.target;
    setFilters(f => ({ ...f, [name]: value }));
  };

  // Apply filters
  useEffect(() => {
    const { searchQuery, fromDate, toDate } = filters;
    const filtered = data.filter(item => {
      const created = new Date(item.CreatedAt);
      const matchesSearch =
        searchQuery === "" ||
        [item.Responsible_Person, item.Department, item.LOT_ID, item.ProcessName]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());
      const matchesDate =
        (fromDate === "" || created >= new Date(fromDate)) &&
        (toDate === "" || created <= new Date(toDate));
      return matchesSearch && matchesDate;
    });
    setFilteredData(filtered);
  }, [filters, data]);

  // Delete handler
  // const handleDelete = async id => {
  //   if (!window.confirm("Are you sure you want to delete this entry?")) return;
  //   try {
  //     await axiosInstance.delete(`/api/delete-checkpoint/${id}`);
  //     fetchCheckPoints();
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //     alert("Failed to delete entry");
  //   }
  // };

  // Approve entry
//   const handleApprove = async row => {
//     if (row.Status === "Approved") return;
//     try {
//       await axiosInstance.patch(
//         `/api/update-checkpoint-status/${row.id}`,
//         { ApprovedBy: supervisor, Status: "Approved" }
//       );
//       // refresh row state locally
//       setData(d => d.map(it => it.id === row.id ? { ...it, ApprovedBy: supervisor, Status: "Approved" } : it));
//       setFilteredData(fd => fd.map(it => it.id === row.id ? { ...it, ApprovedBy: supervisor, Status: "Approved" } : it));
//     } catch (err) {
//       console.error("Approve error:", err);
//       alert("Failed to approve");
//     }
//   };

     const handleApprove = async (id) => {
    try {
      // Disable button immediately by setting remarks state; we'll flip row.Status to “Approving...”
      setData((prev) =>
        prev.map((r) =>
          r.ID === id ? { ...r, Status: "Approving..." } : r
        )
      );

      await axiosInstance.patch(`/api/update-checkpoint-status/${id}`, {
        Status: "Approved",
        ApprovedBy: user?.Name || "Unknown",
      });

      // On success, set that remark’s Status to “Approved”
      setData((prev) =>
        prev.map((r) =>
          r.ID === id ? { ...r, Status: "Approved" } : r
        )
      );
      showAlert("Approved Successfully", "success");
       fetchCheckPoints();
    } catch (err) {
      console.error("Failed to approve remark:", err);
      // Optionally revert the “Approving...” to the previous value or show an alert
     
    }
  };


    const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${
          type === "success" ? "Success!" : "Error!"
        }</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };

 // Update remarks with debounce
  const handleRemarksBlur = (id, value) => {
    const trimmed = value.trim() || null;
    if (trimmed === data.find(r => r.id === id)?.Remarks) return;
    clearTimeout(window.remarkTimeout);
    window.remarkTimeout = setTimeout(async () => {
      try {
        await axiosInstance.patch(`/api/update-checkpoint-remarks/${id}`, { Remarks: trimmed });
        showAlert("Remarks updated", "success");
        fetchCheckPoints();
      } catch (err) {
        console.error("Remarks update error:", err);
        showAlert("Failed to update remarks", "danger");
      }
    }, 800);
  };

  const columns = [
    { name: "Responsible Person",width:"150px", selector: row => row.Responsible_Person, sortable: true },
    { name: "Department",width:"180px", selector: row => row.Department, sortable: true },
    { name: "LOT ID", selector: row => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.LOT_ID}
        >
        {row.LOT_ID}
        </span>
    ), sortable: true },
    // { name: "Process", selector: row => row.ProcessName, sortable: true },
    {
      name: "Checkpoint", width:"300px",
      selector: row => (
        <span data-bs-toggle="tooltip" data-bs-placement="top" title={row.CheckPoints}>
          {row.CheckPoints}
        </span>
      ),
      sortable: true
    },
    { name: "Details",width:"200px", selector: row =>(
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.OtherDetails}
        >
     {row.OtherDetails}
        </span>
    ) },
  
    {
      name: "Remarks",
      cell: row => (
        <textarea
          className="form-control"
          rows={1}
          style={{ fontSize: '12px', width: '150px' }}
          // value={remarks[row.id] || ''}
          value={
            remarks[row.id] !== undefined
              ? remarks[row.id]
              : row.Remarks || ""
          }
          onChange={e => setRemarks(prev => ({ ...prev, [row.id]: e.target.value }))}
          onBlur={e => handleRemarksBlur(row.id, e.target.value)}
          placeholder="Enter Remark"
        />
      ),
      sortable: true
    },
     { name: "Created By",width:"150px", selector: row => row.CreatedBy, sortable: true },
     { name: "Created At",width:"150px", selector: row => row.CreatedAt, sortable: true },
      { name: "Approve Within",width:"150px", selector: row => row.ApproveWithin, sortable: true },
      {
      name: "Approval",
      // In this column, if row.Status === "Approved", show green “Approved” text.
      // If row.Status === "Approving...", disable button and show “Approving…”.
      // Otherwise show a clickable “Approve” button.
      cell: (row) => {
        if (row.Status === "Approved") {
          return (
            <span style={{ color: "green", fontWeight: "bold" }}>
              Approved
            </span>
          );
        } else if (row.Status === "Approving...") {
          return (
            <button className="btn btn-sm btn-secondary" disabled>
              Approving…
            </button>
          );
        } else {
          return (
            <button
              className="btn btn-sm btn-outline-success"
              onClick={() => handleApprove(row.id)}
            >
              Approve
            </button>
          );
        }
      },
      ignoreRowClick: true, // so clicking the button doesn’t select the row
      allowOverflow: true,
      button: true,
    },

    //   {
    //   name: "Actions",
    //   cell: row => (
    //     <button
    //       className="btn btn-sm btn-danger"
    //       onClick={() => handleDelete(row.id)}
    //     >
    //       Delete
    //     </button>
    //   )
    // }
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-2" style={{ height: "-webkit-fill-available" }}>
          <div className="container mt-0">
            <h3 className="mb-4">View Check Points</h3>

                    {/* Filter Section */}
                    <div className="d-flex mb-4 mt-4">
                      <input
                        type="text"
                        name="searchQuery"
                        value={filters.searchQuery}
                        onChange={handleFilterChange}
                        className="form-control me-2"
                        style={{ width: "200px" }}
                        placeholder="Search..."
                      />
                      <input
                        type="date"
                        name="fromDate"
                        value={filters.fromDate}
                        onChange={handleFilterChange}
                        className="form-control me-2"
                        style={{ width: "200px" }}
                      />
                      <input
                        type="date"
                        name="toDate"
                        value={filters.toDate}
                        onChange={handleFilterChange}
                        className="form-control"
                        style={{ width: "200px" }}
                      />
                    </div>

            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              persistTableHead
            />
          </div>
        </main>
      </div>
    </div>
  );
}

export default ViewCheckPoints;
